module.exports = __webpack_public_path__ + "static/media/vienna-12.8aeee6c6.jpg";